import * as React from 'react';

type Props = React.SVGProps<SVGSVGElement> & {
  strokeWidth?: number;
};

export default function CloseIcon({
  strokeWidth = 1,
  className,
  ...rest
}: Props) {
  return (
    <svg
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      className={className}
      aria-hidden='true'
      {...rest}
    >
      <line
        x1='6'
        y1='6'
        x2='18'
        y2='18'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
      <line
        x1='6'
        y1='18'
        x2='18'
        y2='6'
        strokeWidth={strokeWidth}
        strokeLinecap='round'
      />
    </svg>
  );
}
